import { render, staticRenderFns } from "./mobile_demand_detail.vue?vue&type=template&id=05e073d3&scoped=true&"
import script from "./mobile_demand_detail.vue?vue&type=script&lang=js&"
export * from "./mobile_demand_detail.vue?vue&type=script&lang=js&"
import style0 from "./mobile_demand_detail.vue?vue&type=style&index=0&id=05e073d3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e073d3",
  null
  
)

export default component.exports